import {Component, inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogModule} from '@angular/material/dialog';
import {EmProductGroupCardComponent} from '../product-group-card/product-group-card.component';
import {ProductGroupEntity} from '@em/data-feed/util-types';

@Component({
  selector: 'em-product-group-card-modal',
  imports: [MatDialogModule, EmProductGroupCardComponent],
  templateUrl: './product-group-card-modal.component.html',
  styleUrls: ['./product-group-card-modal.component.scss'],
})
export class EmProductGroupCardModalComponent {
  data = inject<{group: ProductGroupEntity}>(MAT_DIALOG_DATA);
}
